<template>
  <div>
    <div class="header">
      <div class="container-fluid container-boxed">
        <div class="header-body">
          <h6 class="header-pretitle">Details</h6>
          <h1 v-if="editingUser" class="header-title">Edit User</h1>
          <h1 v-else class="header-title">Create User</h1>
        </div> <!-- / .header-body -->
      </div>
    </div><!-- / .header -->

    <div class="container-fluid container-boxed">
      <div v-if="creatingUser" class="alert alert-info">
        <strong>Please Note</strong> graduate and manager user accounts can only be created against a program.
      </div><!-- /.alert -->

      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col">
              <h3 class="card-header-title">Account Details</h3>
            </div>

            <div v-if="editingUser" class="col-auto">
              <ladda-button v-if="userIsDisabled" :click="enableUser" class="btn btn-sm btn-outline-success">
                Enable User
              </ladda-button>

              <ladda-button v-else :click="disableUser" class="btn btn-sm btn-outline-danger">
                Disable User
              </ladda-button>
            </div>
          </div><!-- /.row -->
        </div>

        <div class="card-body form-gorup-last">
          <div v-if="editingUser && userIsDisabled" class="alert alert-danger">
            <strong>User Disabled.</strong> Please re-enable the user to grant access to the system.
          </div><!-- /.alert -->

          <div v-if="editingUser" class="form-group">
              <label class="control-label">Username</label>
              <input v-model="stateUsername" v-validate="'required'" name="username" key="username" type="text" class="form-control" />

              <help-block field="username"/>
          </div><!-- /.form-group -->

          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <p class="control-label">First Name</p>
                <input v-model="stateFirstName" v-validate="'required'" data-vv-as="first name" name="first_name" type="text" class="form-control" />

                <help-block field="first_name"/>
              </div><!-- /.form-group -->
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <p class="control-label">Last Name</p>
                <input v-model="stateLastName" v-validate="'required'" data-vv-as="last name" name="last_name" type="text" class="form-control" />
                <help-block field="last_name"/>
              </div><!-- /.form-group -->
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <p class="control-label">GEN Number</p>
                <input v-model="stateGen" v-validate="" name="gen" type="text" class="form-control" />
              </div><!-- /.form-group -->
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label class="control-label">User Type</label>
                <multiselect
                  v-validate="'required'"
                  data-vv-validate-on="input|blur"
                  data-vv-as="user type"
                  v-if="creatingUser"
                  v-model="roleSelected"
                  track-by="value"
                  label="text"
                  name="role"
                  :options="roleOptions"
                  :allow-empty="false"
                  :searchable="false"
                  :show-labels="false"
                  :class="[errorClass('role'), validClass('role')]"
                  placeholder=""/>

                <p v-else class="mt-3">{{ user.role | capitalise }}</p>

                <help-block field="role"/>
              </div><!-- /.form-group -->
            </div>

            <div v-if="userIsGraduate" class="col-sm-6">
              <div class="form-group">
                <label class="control-label">Region</label>
                <multiselect
                  v-validate
                  v-model="regionSelected"
                  data-vv-validate-on="input|blur"
                  track-by="value"
                  label="text"
                  name="region"
                  key="region"
                  :options="regionOptions"
                  :searchable="false"
                  :show-labels="false"
                  :class="[errorClass('region'), validClass('region')]"
                  placeholder=""/>
              </div><!-- /.form-group -->
            </div>

            <div  v-if="!userIsGraduate" class="col-sm-6">
              <div class="form-group">
                <label class="control-label" v-if="!userIsCoordinator || !editingUser">Agency</label>
                <label class="control-label" v-else>Agencies</label>
                <multiselect
                  v-if="!userIsCoordinator || !editingUser"
                  @input="handleSelectAgencyCallback"
                  @search-change="handleSearchAgenciesCallback"
                  :options="agencies"
                  :value="agencySelected"
                  :searchable="true"
                  label="name"
                  track-by="id"
                  placeholder=""
                  name="agency_id"
                  data-vv-validate-on="input|blur"
                  v-validate
                  :class="[errorClass('agency_id'), validClass('agency_id')]"
                  :show-labels="false"/>
                  <p v-if="userIsCoordinator">
                    <span v-for="(agency, index) in user.agencies" :key="agency.id">
                      {{ agency.name }} <span v-if="index + 1 < user.agencies.length">; </span>
                    </span>
                  </p>
              </div><!-- /.form-group -->
            </div>

            <div class="col-sm-6">
              <div class="form-group">
                <label class="control-label">Phone</label>
                <input v-model="statePhone" v-validate="" type="text" name="phone" class="form-control" />
              </div><!-- /.form-group -->
            </div>

            <div class="col-12">
              <div class="form-group">
                <p class="control-label">Backup Email Address</p>
                <input v-model="stateEmail" v-validate="'required'" type="email" name="email" class="form-control" />

                <help-block field="email"/>
              </div><!-- /.form-group -->
            </div>

            <div class="col-12">
              <p class="control-label">Enrolment Options</p>
              <div class="form-group">
                <div class="form-check abc-checkbox abc-checkbox-success">
                  <input v-model="stateUnenrolled" type="checkbox" id="checkunenrolled" class="form-check-input" />
                  <label for="checkunenrolled" class="form-check-label"> Unenrolled in program </label>
                </div>
                <p class="form-text text-muted">
                  <font-awesome :icon="['fal', 'info-circle']"/>
                  <strong> What is this for?</strong> This will remove the user from reminder notifications and from being included in some reports.
                </p>
              </div><!-- /.form-group -->
            </div>

            <div class="col-12 text-right">
              <div class="form-group">
                <ladda-button :click="handleSaveUser" class="btn btn-success">{{ creatingUser ? 'Create User' : 'Save Changes'}}</ladda-button>
              </div><!-- /.form-group -->
            </div>
          </div><!-- /.row -->
        </div>
      </div><!-- /.card -->

      <div v-if="editingUser" class="card">
        <div class="card-body">
          <h3>One-Time Password</h3>

          <p class="mb-0">A one-time password can be generated to allow a user into their account if they cant login or reset their password via email.</p>
          <p>The user will be prompted to update their password when logging in.</p>

          <div class="row">
            <div class="col-auto">
              <ladda-button :click="generateOneTimePassword" class="btn btn-info">
                <font-awesome :icon="['fal', 'magic']"/>
                Generate Password
              </ladda-button>
            </div>

            <div class="col d-flex align-items-center">
              <p class="mb-0">
                <span class="small">One Time Password:</span><br />
                <strong>{{ oneTimePassword }}</strong>
              </p>
            </div>

          </div><!-- /.row -->
        </div>

         <div class="card-body">
          <h3>Reset Password</h3>

          <div class="row">
            <div class="col-auto">
              <ladda-button :click="handleSendPasswordResetEmail" class="btn btn-info">
                Send Password Reset Email
              </ladda-button>
            </div>
          </div><!-- /.row -->
        </div>
      </div><!-- /.card -->

      <LogCard type="user" />
    </div><!-- /.container-fluid -->

    <LogDrawer type="user" :target="user"/>
  </div>
</template>

<script>
import { stateMapper, helpers } from 'mixins/users'
import { userComputed, userMethods, agencyComputed, agencyMethods, authMethods } from 'vx/helpers'
import { debounce, pick } from 'lodash'
import { handleServerErrors, alert } from 'utils'
import Multiselect from 'vue-multiselect'
import { LogCard, LogDrawer } from 'components/log'

export default {
  mixins: [stateMapper, helpers],

  props: {
    id: {
      required: false,
      type: Number,
      default: null
    }
  },

  components: {
    Multiselect,
    LogCard,
    LogDrawer
  },

  computed: {
    ...userComputed,
    ...agencyComputed,

    /**
     * Determine if we are on the user create
     */
    creatingUser () {
      return this.$route.name === 'users.create'
    },

    /**
     * Determine if we are on the user edit route
     */
    editingUser () {
      return this.$route.name === 'users.edit'
    },

    /**
     * Determine if the logged in user is editing themself
     */
    editingSelf () {
      return this.$route.name === 'profile'
    },

    /**
     * Get and set the selected role
     */
    roleSelected: {
      get () {
        return this.roleOptions.find(option => option.value === this.user.role)
      },

      set (option) {
        this.stateRole = option.value
      }
    },

    /**
     * Get and set the selected region
     */
    regionSelected: {
      get () {
        return this.regionOptions.find(option => option.value === this.user.region)
      },

      set (option) {
        this.stateRegion = option.value
      }
    }
  },

  data () {
    return {
      searching: false,
      agencySelected: null,
      oneTimePassword: null,
      roleOptions: [
        {
          value: 'coordinator',
          text: 'Agency Coordinator'
        },
        {
          value: 'admin',
          text: 'Admin'
        }
      ],
      regionOptions: [
        {
          value: 'Greater Metropolitan Sydney',
          text: 'Greater Metropolitan Sydney'
        },
        {
          value: 'NSW Central Tablelands',
          text: 'NSW Central Tablelands'
        },
        {
          value: 'NSW Hunter',
          text: 'NSW Hunter'
        },
        {
          value: 'New England',
          text: 'New England'
        },
        {
          value: 'NSW North Coast',
          text: 'NSW North Coast'
        }
      ]
    }
  },

  async created () {
    this.getAgencies({ 'enabled': 'true' })
    if (this.creatingUser) {
      await this.resetUser()

      return
    }

    try {
      await this.getUser(this.id || this.$user.id)

      this.agencySelected = this.user.agency
    } catch (error) {
      this.$router.replace({ name: 'users' })
    }
  },

  methods: {
    ...userMethods,
    ...agencyMethods,
    ...authMethods,

    /**
     * Update or create the user
     */
    async handleSaveUser () {
      try {
        if (!await this.$validator.validate()) {
          return
        }

        if (this.editingUser || this.editingSelf) {
          let payload = pick(this.user, [
            'first_name',
            'last_name',
            'email',
            'username',
            'gen',
            'unenrolled',
            'agency_id',
            'phone',
            'enabled',
            'region'
          ])

          await this.updateUser({ user: this.user, payload })

          this.$noty.success('User has been updated.')
        } else if (this.creatingUser) {
          await this.storeUser(pick(this.user, [
            'first_name',
            'last_name',
            'email',
            'gen',
            'role',
            'unenrolled',
            'agency_id',
            'phone',
            'enabled'
          ]))

          this.$noty.success('User has been created.')

          this.$validator.reset()

          this.$router.push({ name: 'users.edit', params: { id: this.user.id } })
        }
      } catch (error) {
        handleServerErrors(error, this.$validator)
      }
    },

    /**
     * Generate a one time password for this user and show it
     */
    async generateOneTimePassword () {
      if (this.userIsDisabled) {
        alert.warning({
          title: 'User Disabled',
          text: 'Please enable the user account before generating a one time password.'
        })

        return
      }

      try {
        this.oneTimePassword = await this.storeOneTimePassword(this.user)
      } catch (error) {
        throw error
      }
    },

    /**
     * Send password reset email to the user
     */
    async handleSendPasswordResetEmail () {
      if (this.userIsDisabled) {
        alert.warning({
          title: 'User Disabled',
          text: 'Please enable the user account before sending password reset email.'
        })

        return
      }

      try {
        let payload = {
          identifier: this.user.email,
          type: 'front-end'
        }

        const response = await this.sendPasswordResetEmail(payload)
        if (response.status === 204) {
          this.$noty.success('Password reset email has been sent.')
        }
      } catch (error) {
        throw error
      }
    },

    handleSelectAgencyCallback (agency) {
      this.agencySelected = agency

      this.stateAgency = agency
        ? agency.id
        : null
    },

    handleSearchAgenciesCallback: debounce(async function (title) {
      this.searching = true

      await this.getAgencies({ name: 'agencies' })

      this.searching = false
    }, 600)
  }
}
</script>
